var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuUnFold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:menu-fold-2-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 4L3 10L9 17V4ZM24 25V22.5H1.5V25H24ZM24 16.25V13.75H12.75V16.25H24ZM24 7.5V5H12.75V7.5H24Z",
    fill: "#3C2464"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUnFold);
export default __webpack_public_path__ + "static/media/menuUnFold.fbb19895d04976a95b3800ff5b3cc665.svg";
export { ForwardRef as ReactComponent };